<style lang="less" scoped>
  @import "../../../vars.less";
  .secondary {
    color: @text-color-secondary;
  }
  .button-container {
    padding: @space-normal;
    & > *:not(:last-child) {
      margin-bottom: @space-normal;
    }
  }
  .pt {
    margin-top: @space-small;
    background-color: #fff;
    padding: @space-normal;
    color: @text-color;
  }
  .pt-header {
    font-size: 14px;
    line-height: normal;
    padding-bottom: @space-medium;
    display: flex;
    align-items: center;
    margin-bottom: @space-medium;
  }
  .pt-header-left {
    // font-weight: bold;
    font-size: 16px;
    flex: auto;
  }
  .pt-header-right {
    font-size: 12px;
    flex: none;
    display: flex;
    align-items: center;
    & > *:not(:first-child) {
      margin-left: @space-medium;
    }
  }
  .material-list {
    padding: 0 @space-small;
  }
</style>

<template>
  <page-container class="special-delivery-apply" :title="$t('申请特殊发货')" :loading="applyLoading">
    <van-form label-align="right">
      <van-field rows="1" autosize type="input"
        v-model="form.OrderNumber" :disabled="!!$route.query.orderNumber"
        name="order_number"
        :label="$t('销售订单号')" />
      <van-field type="input"
        v-model="form.SBA" disabled
        name="SBA" :placeholder="$t('请填写商务名称')"
        :label="$t('商务')">
        <van-loading v-if="orderInfoLoading" slot="right-icon" size="24px" />
      </van-field>
      <van-field rows="1" autosize type="textarea"
        v-model="form.ProjectName" :placeholder="$t('请填写项目名称')"
        name="ProjectName"
        :label="$t('项目名称')">
        <!-- <van-loading v-if="orderInfoLoading" slot="right-icon" size="24px" /> -->
      </van-field>
      <picker :label="$t('加急原因')" :placeholder="$t('请选择加急原因')"
        v-model="form.ReasonCategory" value-field="Code" text-field="Name"
        :loading="RCTSLoading" :columns="RCTS" />
      <picker :label="$t('运输方式')" :placeholder="$t('请选择运输方式')"
        v-model="form.TransportType" value-field="Code" text-field="Name"
        :loading="transTypesLoading" :columns="transTypes" />
      <picker :label="$t('运费方式')" :placeholder="$t('请选择运费方式')"
        v-model="form.FreightType" value-field="Code" text-field="Name"
        :loading="freightModesLoading" :columns="freightModes" />
      <van-field :rows="2" autosize type="textarea"
        v-model="form.Remark" maxlength="140" show-word-limit
        name="Remark" :placeholder="$t('请填写描述信息（小于140字）')"
        :label="$t('备注')" />
    </van-form>
    <div class="button-container">
      <van-button block type="info" native-type="submit"
        size="small" round @click="onSubmit"
        :disabled="orderInfoLoading || transTypesLoading || freightModesLoading">
        {{$t('提交')}}
      </van-button>
    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../../components/PageContainer'
import Picker from '../../../components/Picker.vue'
import { Form, Field, Button, Loading, Notify, Toast } from 'vant'

export default {
  name: 'special-delivery-apply',
  components: {
    'van-form': Form,
    'van-field': Field,
    'van-button': Button,
    'van-loading': Loading,
    Picker,
    PageContainer
  },
  data () {
    return {
      form: {
        // 3005015910
        OrderNumber: this.$route.query.orderNumber || '',
        ProjectName: '',
        ReasonCategory: '0',
        TransportType: '1',
        FreightType: '1',
        Remark: '',
        SalesName: '',
        SBA: ''
      },
      orderInfoLoading: false,
      RCTSLoading: false,
      RCTS: [],
      transTypesLoading: false,
      transTypes: [],
      freightModesLoading: false,
      freightModes: [],
      applyLoading: false
    }
  },
  methods: {
    getOrderInfo () {
      this.$apis.care.getOrderInfo(
        this.$route.query.orderNumber,
        loading => (this.orderInfoLoading = loading),
        (err) => {
          // code 204 means this order has been applied for urgent
          if (err.ErrorCode === '204') {
            this.$back()
          }
          return true
        }
      ).then(res => {
        if (res) {
          this.form.SalesName = res.SalesName
          this.form.SBA = res.BAName || ''
          // this.form.ProjectName = res.ProjectName || ''
        }
      })
    },
    getReasonCategories () {
      this.$apis.basic.getReasonCategories(
        loading => (this.RCTSLoading = loading)
      ).then(res => {
        if (res && res.length) {
          this.RCTS = res
          this.form.ReasonCategory = res[0].Code
        }
      })
    },
    getTransTypes () {
      this.$apis.care.getTransportTypes(
        loading => (this.transTypesLoading = loading)
      ).then(res => {
        if (res && res.length) {
          this.transTypes = res
          this.form.TransportType = res[0].Code
        }
      })
    },
    getFreightModes () {
      this.$apis.care.getFreightModes(
        loading => (this.freightModesLoading = loading)
      ).then(res => {
        if (res) this.freightModes = res
      })
    },
    onSubmit () {
      if (!this.form.ProjectName.trim()) {
        Toast(this.$t('请填写项目名称'))
        return
      }

      // if (!this.form.SBA.trim()) {
      //   Toast(this.$t('请填写商务名称'))
      //   return
      // }

      if (!this.form.Remark.trim()) {
        Toast(this.$t('请填写描述信息'))
        return
      }

      this.$apis.care.applySpecialDelivery(
        this.form,
        loading => (this.applyLoading = loading)
      ).then(res => {
        if (res) {
          Notify({ type: 'success', message: this.$t('特殊发货申请成功') })
          this.$back()
        }
      })
    },
    onRDDLConfirm (value) {
      this.form.ReqestDeliveryDateLast = value.toString()
      this.RDDLShow = false
    }
  },
  mounted () {
    this.getOrderInfo()
    this.getReasonCategories()
    this.getTransTypes()
    this.getFreightModes()
  }
}
</script>
